export { default } from './EmprestimoGarantiaCarroCompare';
